import { useEffect, useState } from 'react';
import { useSucursal } from '../contexts/SucursalContext';
import { useUser } from '../contexts/UserContext';
import Swal from 'sweetalert2';

const useCajaAbiertaValidation = () => {
    const server = process.env.REACT_APP_API_ROUTE;
    const { user } = useUser();
    const { sucursalSeleccionada, cajaAbierta } = useSucursal();
    const [validacionCompleta, setValidacionCompleta] = useState(false);

    const validarCajaAbierta = async (mostrarMensaje = true) => {
        try {
            if (!user || !sucursalSeleccionada) {
                return false;
            }

            const response = await fetch(
                `${server}/MgCajaDenominaciones/validar-caja-abierta/${user.codigoUsuario}/${sucursalSeleccionada.idSucursal}`
            );

            if (response.ok) {
                const data = await response.json();
                
                if (!data.cajaAbierta && mostrarMensaje) {
                    Swal.fire({
                        title: 'Caja Cerrada',
                        text: 'Debe abrir la caja antes de realizar esta operación',
                        icon: 'warning',
                        confirmButtonText: 'Entendido'
                    });
                }

                setValidacionCompleta(true);
                return data.cajaAbierta;
            }

            return false;
        } catch (error) {
            console.error('Error al validar caja abierta:', error);
            if (mostrarMensaje) {
                Swal.fire('Error', 'No se pudo validar el estado de la caja', 'error');
            }
            return false;
        }
    };

    useEffect(() => {
        if (user && sucursalSeleccionada) {
            validarCajaAbierta(false);
        }
    }, [user, sucursalSeleccionada]);

    return {
        validarCajaAbierta,
        cajaAbierta,
        validacionCompleta
    };
};

export default useCajaAbiertaValidation;
